export class State {
    id: number;
    code: string;
    initials: string;
    name: string;
    gentile: string
   
}